module.exports = __webpack_public_path__ + "static/home-quick-withdrawals-58502f04704cf2393884b3dcef2c07f0.png";